import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import { DashboardItem, MenuItem, Toast, toastFactory, UserProfile } from '../../models';

import * as fromActions from '../actions/user-profile.actions';
import * as fromErrors from '../actions/errors.actions';
import { AppConfig } from 'src/app/models/app-config.model';

export const userProfileFeatureKey = 'userProfile';


export enum Loaders {
  loadingUserProfile = 'Loading user profile...',
  loadingMenu = 'Loading Menu...',
  loadingDashboard = 'Loading Dashboard...',
  loadingConfig = "loadingConfig"
}
export interface State {
  profile: UserProfile | null;
  menuItems: MenuItem[];
  loaders: Loaders[];
  cache: { [key: string]: string };
  hasLoadedUser: boolean;
  appConfig: AppConfig[];
  dashboardItems: DashboardItem[];
}

export const initialState: State = {
  profile: null,
  menuItems: [],
  loaders: [],
  cache: {},
  hasLoadedUser: false,
  appConfig: [],
  dashboardItems: []
};

export const reducer = createReducer(
  initialState,
  on(fromActions.loadUserProfile, (state, action) => ({
    ...state,
    loaders: [...state.loaders, Loaders.loadingUserProfile, Loaders.loadingMenu],
    hasLoadedUser: false // reset this in case we want to reload the user profile
  })),
  on(fromActions.loadUserProfileSuccess, (state, action) => ({
    ...state,
    profile: action.profile,
    loaders: state.loaders.filter(f => f !== Loaders.loadingUserProfile),
    hasLoadedUser: true
  })),
  on(fromActions.loadMenuSuccess, (state, action) => ({
    ...state,
    menuItems: action.menuItems,
    loaders: state.loaders.filter(f => f !== Loaders.loadingMenu)
  })),
  on(fromActions.loadDashboardSuccess, (state, action) => ({
    ...state,
    dashboardItems: action.dashboardItems,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDashboard)
  })),
  on(fromActions.loadUserProfileFailure, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingMenu)
  })),
  on(fromActions.loadAppConfig, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingConfig)
  })),
  on(fromActions.loadAppConfigSuccess, (state, action) => ({
    ...state,
    appConfig: action.config,
    loaders: state.loaders.filter(f => f !== Loaders.loadingConfig)
  })),
  on(fromActions.loadAppConfigFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingConfig)
  }))
);
